import * as React from "react";
import { SvgIcon } from "./SvgIcon";
import { SupportIcon, Triangle } from "@icons";
import { AppState, sendSupportMessageAction } from "@store";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as cn from "classnames";

import "./SupportComponent.css";
import { LoadingSpinner } from "./LoadingSpinner";
import { FetchingState } from "rd-redux-http";

export interface SupportComponentProps {
    onSend: (message: string) => void;
    isSending: boolean;
}

export interface SupportComponentState {
    msgBlockStatus: boolean;
    message: string;
}

export class SupportComponent extends React.Component<SupportComponentProps, SupportComponentState> {
    constructor(props: SupportComponentProps) {
        super(props);
        this.state = {
            msgBlockStatus: false,
            message: ""
        };

        this.changeMsgBlockStatus = this.changeMsgBlockStatus.bind(this);
    }

    changeMsgBlockStatus(status: boolean) {
        this.setState({
            ...this.state,
            msgBlockStatus: status
        });
    }

    handleChangeMessage(e: any) {
        this.setState({
            ...this.state,
            message: e.target.value
        });
    }

    handleOnSend() {
        this.props.onSend(this.state.message);
        this.setState({
            ...this.state,
            message: ""
        });
        this.changeMsgBlockStatus(false);
    }

    render() {
        const { msgBlockStatus, message } = this.state;
        const { isSending } = this.props;

        return (
            <div className="support-block">
                <div className={cn("support-msg", msgBlockStatus ? "active" : "")}>
                    <div className="support-msg_header-block">
                        <h4 className="support-msg_title">Send us a message</h4>
                        <span className="support-msg_close-btn" onClick={() => this.changeMsgBlockStatus(false)} />
                    </div>
                    <div className="support-msg_main-block">
                        <textarea
                            className="support-msg_msg-texarea"
                            placeholder="Our Adello Support team is happy to help you Monday-Friday 1am UTC - 4pm UTC. Mail: support@adello.com"
                            value={message}
                            onChange={e => this.handleChangeMessage(e)}
                        />
                        <p className="support-msg_hint-text">
                            For Gold Level support please call your dedicated EOC-Gold number as provided by your key
                            account member.
                        </p>
                        <button
                            className="common-btn support-msg_send-btn"
                            disabled={false}
                            onClick={() => this.handleOnSend()}
                        >
                            Send<SvgIcon className="support-msg_btn-svg" svg={Triangle} />
                        </button>
                    </div>
                </div>
                <div
                    className={cn(
                        "support-icon",
                        msgBlockStatus ? "" : "active",
                        isSending ? "support-icon_loading" : ""
                    )}
                    onClick={() => !isSending && this.changeMsgBlockStatus(true)}
                >
                    <SvgIcon svg={SupportIcon} />
                    {isSending && (
                        <div className="support__loading">
                            <LoadingSpinner />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export interface SupportProps {}

export const Support = connect(
    (state: AppState, ownProps: SupportProps) => ({
        isSending: FetchingState.isFetching(state.pagesState.supportMessage)
    }),
    (dispatch: Dispatch, ownProps: SupportProps) => ({
        onSend: (message: string) => {
            dispatch(sendSupportMessageAction({ message: message }));
        }
    })
)(SupportComponent);
